import { isSSR } from '#shared/utils/isSSR';
import devProxyApiUrl from '~/utils/devProxyApiUrl';
import { buildHeaderRequestUrl } from '#shared/utils/headerHelpers';
import { buildFooterRequestUrl } from '#shared/utils/footerHelpers';

export function buildNavigationUrl(pathName, options) {
  const { clientBaseUrl, serverBaseUrl } = options;
  const baseUrl = isSSR() ? serverBaseUrl : clientBaseUrl;

  if (isSSR()) {
    // On the server, construct a full URL to make a direct external request
    return new URL(pathName, baseUrl).href;
  }

  // On the client, use the proxy utility which should also result in a string URL
  const proxy = devProxyApiUrl(baseUrl);
  return proxy(pathName);
}

function buildHeaderUrl(params) {
  return buildNavigationUrl(buildHeaderRequestUrl(params), params);
}

function buildFooterUrl(params) {
  return buildNavigationUrl(buildFooterRequestUrl(params), params);
}

export function useHeaderFetch(options) {
  return $fetch(buildHeaderUrl(options));
}

export function useFooterFetch(options) {
  return $fetch(buildFooterUrl(options));
}

export function useKillSwitchesFetch(options) {
  return $fetch(buildNavigationUrl('/xapi/navigate/v1/header-footer/switches', options));
}
